
import { defineComponent } from 'vue';
import { CloseBold } from '@element-plus/icons';

import SvgIcon from '@/components/Icons/SvgIcon.vue';
import { FILESERVICE } from '@/config/defaultSetting';
import { ExternalSystemApiSerivce } from '@/api/external-system/index';
import { UserApiSerivce } from '@/api/user';

export default defineComponent({
  name: 'WMSClientDialog',
  components: {
    SvgIcon,
    CloseBold,
  },
  props: {
    username: {
      type: String,
      default: '',
    },
  },
  emits: ['closeDia'],
  setup(props, context) {
    function onClose() {
      context.emit('closeDia', undefined);
    }

    function toWMSClient(isClient: boolean) {
      ExternalSystemApiSerivce.getK3cloudUrl({
        userName: props.username,
      }).then((resolve) => {
        const href = isClient ? resolve.clientLoginUrl : resolve.html5LoginUrl;

        window.open(href, '_blank');

        onClose();
      });
    }

    function toIWMSClient() {
      UserApiSerivce.onIwmsLogin().then((res) => {
        window.open(res.iwmsLoginUrl, '_blank');

        onClose();
      });
    }

    return {
      onClose,
      toWMSClient,
      toIWMSClient,
      FILESERVICE,
    };
  },
});
